export enum URLParam {
  StartDate = "startDate",
  EndDate = "endDate",
  GuestCount = "guestCount",
  Language = "lang",
  RateGroup = "rateGroup",
  Parcel = "parcel",
  AccommodationType = "accType",
  PaymentResult = "paymentResult",
  ReservationOffer = "reservationOffer",
}
